/**
 * Save user session to localStorage
 * @param {Object} user - User object with id, email, and role
 */
export const saveSession = (user) => {
  localStorage.setItem('user', JSON.stringify(user));
};

/**
 * Get user session from localStorage
 * @returns {Object|null} User object or null if no session exists
 */
export const getSession = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

/**
 * Clear user session from localStorage
 */
export const clearSession = () => {
  localStorage.removeItem('user');
};
